export default __webpack_public_path__ + "static/media/aero.02d9fb24.png";